import { Expose } from "class-transformer";

export class AddPlanningBoardProjectDto {
  @Expose()
  projectId: string;
}
